export default __webpack_public_path__ + "static/media/8.56f45585.jpg";